import { api } from '@/lib/api'

type DeleteDocumentParams = {
  documentName: string
  businessId: string
  beneficialOwnerId: string
  step: string
}

export function deleteProofOfAddress({
  documentName,
  businessId,
  beneficialOwnerId,
  step,
}: DeleteDocumentParams) {
  const data = {
    details: {
      businessId,
      beneficialOwnerId,
    },
    step,
  }
  return api.delete<void>(`/v1/me/bank-eligibility/documents/${documentName}`, {
    data,
  })
}
